import React from 'react';
import TestimonialCard from './TestimonialCard'; // The path is now correct
import styles from './TestimonialsScroller.module.css';

const TestimonialsScroller = ({ testimonials, direction }) => {
  const duplicatedTestimonials = [...testimonials, ...testimonials];

  return (
    <div className={styles.scroller} data-direction={direction}>
      <div className={styles.scrollerInner}>
        {duplicatedTestimonials.map((testimonial, index) => (
          <div key={index} className="flex-shrink-0 w-full md:w-[450px]">
            <TestimonialCard testimonial={testimonial} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TestimonialsScroller;